import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class EquityHoldingLiveNewsUseCase extends BaseUseCase {
    constructor(commonQuotesHomePageRepository) {
        super();
        this.commonQuotesHomePageRepository = commonQuotesHomePageRepository;
    }
    async fetchResult(requestData) {
        return await this.commonQuotesHomePageRepository.getEquityHoldingLiveNews(requestData);
    }
}
